import { CSSProperties, FC } from 'react';

import clsx from 'clsx';

import { MetaHeaderItems } from './components/MetaHeaderItems/MetaHeaderItems';
import styles from './n21MetaHeader.module.css';
import type { MetaHeaderItemUnion } from './types';

export interface IN21MetaHeaderProps {
	items: MetaHeaderItemUnion[];
	moduleBackgroundColor?: string;
}

const colorIsDark = (color: string) => {
	// Expect color in hex format #RRGGBB. Compute luminance and decide if it's dark.
	if (!color || !color.startsWith('#') || color.length < 7) return false;
	const r = parseInt(color.slice(1, 3), 16);
	const g = parseInt(color.slice(3, 5), 16);
	const b = parseInt(color.slice(5, 7), 16);
	// Perceived luminance
	const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
	return luminance < 128;
};

export const N21MetaHeader: FC<IN21MetaHeaderProps> = ({ items, moduleBackgroundColor }) => {
	// Use CSS variable for background, but need hex fallback for JS luminance calculation
	// Fallback to light color for colorIsDark check when no explicit color provided
	const backgroundColor = moduleBackgroundColor ?? 'var(--color-meta-menu-default-background-color)';
	// For JS luminance check, only evaluate if explicit hex color is provided
	const isDark = moduleBackgroundColor ? colorIsDark(moduleBackgroundColor) : false;

	return (
		<nav
			className={clsx(styles.root, { [styles.isDark]: isDark })}
			style={{ '--n21bg': backgroundColor } as CSSProperties}
			aria-label="Meta Header"
		>
			<MetaHeaderItems items={items} />
		</nav>
	);
};
